import { styled } from "styled-components";

export const EditContactContainer = styled.div``;
